import React, {useCallback} from 'react';
import Combobox from '@ls/react-combobox-grid';
import {useDispatch, useSelector} from 'react-redux';
import {selectAllEntities, selectFetchingEntities} from 'state/selections/selectors';
import {addEntityId} from 'state/selections/actions';

const columnDefs = [
    {
        headerName: 'Entity ID',
        field: 'entityId',
        width: 75,
        suppressSizeToFit: false,
    },
    {
        headerName: 'Entity',
        field: 'label',
      //  suppressSizeToFit: true,
    },
];

const EntitySelector = props => {
    const dispatch = useDispatch();
    const entities = useSelector(selectAllEntities);
    const fetchingEntities = useSelector(selectFetchingEntities);
    const onChange = useCallback((values) => {
        dispatch(addEntityId(values[0]));
    }, [dispatch]);

    return (
        <Combobox
            options={entities}
            onChange={onChange}
            value={null}
            loading={fetchingEntities}
            placeholder="Add Entities..."
            label="Entities:"
            valueKey="entityId"
            labelKey="label"
            columnDefs={columnDefs}
            variation={1}
            multi
        />
    );
};

export default EntitySelector;
